import { EOtherCommunications } from '../../types/filters';

interface IOtherCommunications {
  label: string;
  value: EOtherCommunications;
}

export const OTHER_COMMUNICATIONS: IOtherCommunications[] = [
  { label: 'Канализация', value: EOtherCommunications.Drainage },
  { label: 'Электричество', value: EOtherCommunications.Electricity },
  { label: 'Газ', value: EOtherCommunications.Gas },
  { label: 'Водоснабжение', value: EOtherCommunications.Water },
];
